import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { javascriptData } from "../../../../Data/MiscellaneousData/EditorsData";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { JavascriptModeTitle } from "../../../../Utils/Constants";

export default function JavascriptMode() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={JavascriptModeTitle} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={javascriptData} language="javascript">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
}
